import {
  GET_CLIENT,
  SET_LOADED_CLIENT,
  GET_TOTAL_MONEY
} from 'src/store/mutation-types'

export default {
  [GET_CLIENT] (state, client) {
    state.client = client
  },
  [SET_LOADED_CLIENT] (state, data) {
    state.clientsLoaded[data.id] = data
  },
  [GET_TOTAL_MONEY] (state, totalMoney) {
    state.totalMoney = totalMoney
  }
}



// WEBPACK FOOTER //
// ./src/components/client/store/mutations.js